<template>
  <AddSalesTerritory
    :dialogTitle="title"
    :centerDialogVisible="visible"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'800px'"
    :showBtn="!disableFlag"
    popupTop="10vh"
  >
    <!--<div style="height: 500px; overflow-y: auto" >-->
    <el-form :model="param" label-width="120px" :disabled="disableFlag">
      <el-form-item label="销售区域名称：" prop="salesScopeName">
        <el-input v-model.trim="param.salesScopeName" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="可售区域选择" prop="salesScopeAreas">
        <el-tree
          :data="param.treeData"
          show-checkbox
          ref="tree"
          node-key="areaCode"
          :default-expanded-keys="param.expandKeys"
          :default-checked-keys="param.checkedKeys"
          :props="defaultProps"
        >
        </el-tree>
      </el-form-item>
    </el-form>
    <!--</div>-->
  </AddSalesTerritory>
</template>

<script>
import AddSalesTerritory from "../../../../components/common/epecDialog";
import api from "../../api/product";
export default {
  name: "addSalesTerritory",
  components: {
    AddSalesTerritory,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      param: {
        salesScopeId: "",
        salesScopeName: "",
        treeData: [],
        result: "",
        checkedKeys: [],
        expandKeys: [],
      },
      disableFlag: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  created() {
    // this.assembleTreeData();
  },
  methods: {
    updateVisible() {},
    resetPopupData() {
      this.$emit("cancel");
    },
    submitPopupData() {
      this.getCheckedKeys();
      // this.getCheckedNodes();
      this.$emit("save", this.param);
    },
    // 编辑,新增的时候调这个接口,获取树信息
    assembleTreeData() {
      api.queryAreaConfig4Inst({}).then((res) => {
        this.param.result = res.data;
        let wholeTreeData = [];
        let treeDataArray = res.data;
        console.log();
        let firstGrade = [];

        for (let i = 0; i < treeDataArray.length; i++) {
          if (treeDataArray[i].provinceCode === "0") {
            firstGrade.push(treeDataArray[i]);
          }
        }
        for (let j = 0; j < firstGrade.length; j++) {
          let stepData = {};
          stepData.areaCode = firstGrade[j].areaCode;
          stepData.label = firstGrade[j].areaName;
          stepData.isSale = firstGrade[j].isSale;
          let childrens = [];
          for (let k = treeDataArray.length - 1; k >= 0; k--) {
            if (treeDataArray[k].provinceCode === firstGrade[j].areaCode) {
              let children = {};
              children.areaCode = treeDataArray[k].areaCode;
              children.label = treeDataArray[k].areaName;
              children.isSale = treeDataArray[k].isSale;
              childrens.push(children);
            }
          }
          stepData.children = childrens;
          wholeTreeData.push(stepData);
        }

        this.param.treeData = wholeTreeData;
      });
    },
    getCheckedKeys() {
      this.param.checkedKeys = this.$refs.tree.getCheckedKeys();
    },
    // 编辑传入的是列表数据
    setChecked(val) {
      this.param.checkedKeys = [];
      this.param.expandKeys = [];
      // 获取所有数据
      api.queryAreaConfig4Edit({ salesScopeId: val.salesScopeId }).then((res) => {
        console.log(res, "queryAreaConfig4Edit");
        console.log(this.param, "this.param");
        let checkedArray = [];
        let expendArray = [];
        for (let i = 0; i < res.data.length; i++) {
          if (1 === res.data[i].isSale) {
            checkedArray.push(Number(res.data[i].areaCode));
            // 这需要把provinceCode取到 就解决了省份下的市不展开的问题
            expendArray.push(Number(res.data[i].provinceCode));
            /* if ("0" === res.data[i].provinceCode) {
              expendArray.push(Number(res.data[i].areaCode));
            } */
          }
        }
        this.param.checkedKeys = checkedArray; // 默认选中节点
        this.param.expandKeys = expendArray; //默认展开节点 如果是省份下面的市就没发展开
      });
      this.param.salesScopeName = val.salesScopeName;
      this.param.salesScopeId = val.salesScopeId;
    },
    setDisabledFlag(val) {
      this.disableFlag = val;
    },
    handleClear() {
      this.param.salesScopeId = "";
      this.param.salesScopeName = "";
      this.param.checkedKeys = [];
      this.param.expandKeys = [];
    },
  },
};
</script>

<style lang="scss" scoped>
// .dialog-head {
//   width: 100%;
//   height: 30px;
//   background: #ececec;
//   line-height: 30px;
//   padding-left: 10px;
// }
</style>
